import styles from "./TimelineNow.module.scss";

const MINUTES_MS: number = 1000 * 60;

interface TimelineNowProps {
  size: number;
  start: Date;
  end: Date;
  overlapEnd?: Date;
};

const TimelineNow: React.FC<TimelineNowProps> = ({
  start,
  end,
  size,
  overlapEnd,
}) => {
  const now = new Date();
  let nowShow = now >= start && now <= end;

  // Se há overlapEnd e o tempo atual já passou do início do overlap,
  // não mostrar a barra neste evento (ela aparecerá no próximo)
  if (overlapEnd && now >= overlapEnd) {
    nowShow = false;
  }

  const totalMinutes = (end.getTime() - start.getTime()) / MINUTES_MS;
  const nowMinutes = (now.getTime() - start.getTime()) / MINUTES_MS;

  const nowLeftPx = (nowMinutes / totalMinutes) * size;

  return (
    <>
      {nowShow && (
        <div className={styles.now} style={{ left: `${nowLeftPx}px` }}>
          <div className={styles.nowline} />
          <div className={styles["nowtag-triangle"]} />
        </div>
      )}
    </>
  );
}

export default TimelineNow;